"use strict";
/** state: Final **/
/** family: Input **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var CLASS_NAME = 'i-input';
var InputType;
(function (InputType) {
    InputType["Color"] = "color";
    InputType["Date"] = "date";
    InputType["Email"] = "email";
    InputType["Number"] = "number";
    InputType["Password"] = "password";
    InputType["Range"] = "range";
    InputType["Search"] = "search";
    InputType["Text"] = "text";
    InputType["Url"] = "url";
})(InputType = exports.InputType || (exports.InputType = {}));
var Input = (function (_a) {
    var className = _a.className, defaultValue = _a.defaultValue, inputRef = _a.inputRef, onChange = _a.onChange, step = _a.step, minLength = _a.minLength, maxLength = _a.maxLength, restProps = __rest(_a, ["className", "defaultValue", "inputRef", "onChange", "step", "minLength", "maxLength"]);
    var _b;
    return (React.createElement("input", __assign({ className: classNames(className, CLASS_NAME, 'form-control', (_b = {
                'custom-range': restProps.type === InputType.Range
            },
            _b[CLASS_NAME + "--color"] = restProps.type === InputType.Color,
            _b[CLASS_NAME + "--number"] = restProps.type === InputType.Number,
            _b[CLASS_NAME + "--read-only"] = restProps.readOnly,
            _b)), defaultValue: defaultValue, onChange: restProps.readOnly ? null : onChange, ref: inputRef, step: !step && restProps.type === InputType.Number ? 'any' : step, minLength: minLength, maxLength: maxLength }, restProps)));
});
exports.Input = Input;
Input.Type = InputType;
//# sourceMappingURL=Input.js.map